module.exports = __webpack_public_path__ + "img/nowifi.13b1e235.svg";